<div class="m-show-more"
     v-if="isVisible">
    <div class="m-show-more__status"
         ref="countTotal">{{ status }}</div>
    <m-progress v-if="isProgressVisible"
                :value="visiblePourcentage"
                :border-radius="false"
                :skin="skin"
                ref="progress"></m-progress>
    <m-button v-if="isButtonVisible"
              :skin="buttonSkin"
              @click="showMore"
              :waiting="loading"
              ref="button">{{ buttonLabel }}</m-button>
</div>
